import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ResponseSupervisingEngineeringPriceFloor extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  responseSupervisingEngineerFloorPrice: this.props.responseSupervisingEngineerFloorPrice,
                  selectedResponseSupervisingEngineerFloor: {
                        value: this.props.responseSupervisingEngineerFloorPrice.response_supervising_engineer_floor_id,
                        label: this.props.responseSupervisingEngineerFloorPrice.response_supervising_engineer_floor_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionResponseSupervisingEngineerFloor: [],
            }
      }
      componentDidMount() {
            this.getoptionResponseSupervisingEngineerFloor()
      }

      getoptionResponseSupervisingEngineerFloor = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].response_supervising_engineer_floor_id,
                                          label: arr.data[k].response_supervising_engineer_floor_name,
                                    })
                              }
                              self.setState({ optionResponseSupervisingEngineerFloor: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_response_supervising_engineer_floor")
            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedResponseSupervisingEngineerFloor) => {
            var temparray = this.state.responseSupervisingEngineerFloorPrice
            temparray.response_supervising_engineer_floor_id = selectedResponseSupervisingEngineerFloor.value
            this.setState({
                  selectedResponseSupervisingEngineerFloor: selectedResponseSupervisingEngineerFloor,
                  responseSupervisingEngineerFloorPrice: temparray,
            })
      }

      handleChangeMedicPrice = (event) => {
            var temparray = this.state.responseSupervisingEngineerFloorPrice
            temparray.response_supervising_engineer_price_floor_calculator = event
            this.setState({ responseSupervisingEngineerFloorPrice: temparray })
      }

      handleChangeMedicResident = (event) => {
            var temparray = this.state.responseSupervisingEngineerFloorPrice
            temparray.response_supervising_engineer_price_floor_viewer = event
            this.setState({ responseSupervisingEngineerFloorPrice: temparray })
      }
      handleChangeMedicFellowship = (event) => {
            var temparray = this.state.responseSupervisingEngineerFloorPrice
            temparray.response_supervising_engineer_price_floor_designer = event
            this.setState({ responseSupervisingEngineerFloorPrice: temparray })
      }


      modifyNewInstalmentCondition = () => {
            const { responseSupervisingEngineerFloorPrice } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_add_RSE_price_floor")
            fd.append("response_supervising_engineer_price_floor_id", responseSupervisingEngineerFloorPrice.response_supervising_engineer_price_floor_id)
            fd.append("response_supervising_engineer_price_floor_designer", responseSupervisingEngineerFloorPrice.response_supervising_engineer_price_floor_designer)
            fd.append("response_supervising_engineer_price_floor_calculator", responseSupervisingEngineerFloorPrice.response_supervising_engineer_price_floor_calculator)
            fd.append("response_supervising_engineer_price_floor_viewer", responseSupervisingEngineerFloorPrice.response_supervising_engineer_price_floor_viewer)

            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { responseSupervisingEngineerFloorPrice } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_response_supervising_engineer_price_floor")
            fd.append("response_supervising_engineer_price_floor_id", responseSupervisingEngineerFloorPrice.response_supervising_engineer_price_floor_id)

            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {
                  optionResponseSupervisingEngineerFloor,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedResponseSupervisingEngineerFloor,
                  responseSupervisingEngineerFloorPrice,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={3}>
                                    <div>
                                          <label className="on">طبقه</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"طبقه"}
                                                value={selectedResponseSupervisingEngineerFloor}
                                                onChange={this.handleInstalmentMode}
                                                options={optionResponseSupervisingEngineerFloor}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="قیمت محاسب"
                                          handleInputt={this.handleChangeMedicPrice}
                                          value={responseSupervisingEngineerFloorPrice.response_supervising_engineer_price_floor_calculator}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="قیمت ناظر"
                                          handleInputt={this.handleChangeMedicResident}
                                          value={responseSupervisingEngineerFloorPrice.response_supervising_engineer_price_floor_viewer}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                        type="currency"
                                        placeholder="قیمت طراح"
                                        handleInputt={this.handleChangeMedicFellowship}
                                        value={responseSupervisingEngineerFloorPrice.response_supervising_engineer_price_floor_designer}
                                    />
                              </Grid>

                              <Grid item xs={1}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ResponseSupervisingEngineeringPriceFloor)
